import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { previewHistoryBatch } from '../../../../store/extensions';
import SliderRangeListItem from '../../../../../../list-items/SliderListItem/SliderRangeListItem';

const ParticlesOpacityListItem = (props) => {
    const { minOpacity, maxOpacity, index, updateParticleElement, maxParticleOpacity } = props;

    const onOpacityChange = (value) => {
        previewHistoryBatch.start();
        updateParticleElement(index, { minOpacity: value[0], maxOpacity: value[1] });
    };

    return (
        <SliderRangeListItem
            title='Opacity'
            value={[minOpacity, maxOpacity]}
            displayMultiplier={1}
            min={0}
            max={maxParticleOpacity}
            step={0.01}
            onValueChange={onOpacityChange}
            hideArrows
            preventRound
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];
    const { maxParticleOpacity } = state.create.maxValues;

    return {
        minOpacity: particleElement.minOpacity,
        maxOpacity: particleElement.maxOpacity,
        maxParticleOpacity
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    return { updateParticleElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesOpacityListItem);